import React from "react";
import classNames from "classnames";

const Input = ({ className, placeholder, isError, type, title, name, id, onChange, value, onBlur, disabled, variant }) => {
  return (
    <input
      id={id}
      type={type}
      name={name}
      title={title}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      onBlur={onBlur}
      disabled={disabled}
      className={classNames(
        "w-full px-10px py-10px text-16px",
        {
          "text-blue placeholder:text-blue border-b-[1px] border-b-blue !px-5px bg-transparent": variant === "blue",
          "border-red-primary": isError,
          "border-transparent": !isError,
          "hover:border-blue-secondary focus-visible:border-blue-secondary focus-visible:outline-none": !disabled,
          "opacity-60": disabled,
        },
        className
      )}
    />
  );
};

export default Input;
